import {
  question31,
  question32,
  question33,
  question34,
  question35,
  question36,
} from "assets/images";
import CustomButton from "components/form";
import React from "react";

const Question4 = ({
  bodyFlauntContentHeading,
  bodyDownContentHeading,
  setBodyFlauntContentHeading,
  setBodyDownContentHeading,
  addOrUpdateQuestion,
  buttonLoaders,
  errors,
}) => {
  return (
    <>
      <div className="form_field page_title">
        <label className="label">Body Flaunt Content Heading</label>
        <input
          type="text"
          className="form-control input"
          placeholder="Enter Body Flaunt Content Heading"
          value={bodyFlauntContentHeading}
          onChange={(e) => setBodyFlauntContentHeading(e.target.value)}
        />
        {errors.bodyFlauntContentHeading && (
          <span className="error">{errors.bodyFlauntContentHeading}</span>
        )}
      </div>

      <div className="form_field page_title">
        <label className="label">Body Down Content Heading</label>
        <input
          type="text"
          className="form-control input"
          placeholder="Enter Body Down Content Heading"
          value={bodyDownContentHeading}
          onChange={(e) => setBodyDownContentHeading(e.target.value)}
        />
        {errors.bodyDownContentHeading && (
          <span className="error">{errors.bodyDownContentHeading}</span>
        )}
      </div>
      <h4>Options to answer</h4>
      <div className="onboardingStep-1">
        {[
          { src: question31, tag: "Neckline" },
          { src: question32, tag: "Waist" },
          { src: question33, tag: "Lags" },
          { src: question34, tag: "Arms" },
          { src: question35, tag: "Buttocks" },
          { src: question36, tag: "Back" },
        ].map((item, index) => (
          <div className="item" key={index}>
            <div className="_card">
              <img src={item.src} alt={item.tag} />
              <span className="card_tag">{item.tag}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="button_wrap">
        <CustomButton ref={buttonLoaders} onClick={addOrUpdateQuestion}>
          Save
        </CustomButton>
      </div>
    </>
  );
};

export default Question4;
